export enum AfterSuiteRunType {
  RUN_AFTER_SUITE = 'RUN_AFTER_SUITE',
  RUN_AFTER_EACH_CASE = 'RUN_AFTER_EACH_CASE',
}

export enum AfterSuiteFailActionType {
  IGNORE = 'IGNORE',
  FAIL = 'FAIL',
}
